import { createContext } from 'react';
import type { DeliveryType } from 'shared/src/enums';

/**
 * 찜탭 등 GoodsDetail route 밖에서 옵션 시트/PDP 미리보기를 띄울 때(EXP1768),
 * goodsId/couponSno 를 react-navigation route 대신 주입하기 위한 컨텍스트.
 * 주입되면 useGoodsSno/useFixedCouponSno 가 route 보다 이 값을 우선한다.
 */
export type GoodsParams = {
  goodsId: number;
  couponSno?: number;
  /**
   * route 밖(찜탭 등)에서는 PDP 상세 API(useGoodsDetail/useGoodsBasic)를 호출하지 않으므로,
   * 옵션 시트 로깅에 필요한 값을 카드 데이터로 대신 주입한다.
   * 주입되면 두 PDP 쿼리는 비활성화되고, 로깅 훅은 이 값을 사용한다. (iOS OptionSelectionData(from:) 대응)
   */
  logging?: GoodsParamsLogging;
};

export type GoodsParamsLogging = {
  screen: string;
  folderSno: number | null;
  marketSno: number;
  deliveryType: DeliveryType;
};

export const GoodsParamsContext = createContext<GoodsParams | undefined>(
  undefined,
);
